module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_is-object.js
// module id = 30
// module chunks = 21